import {Injectable} from "@angular/core";
import {SignUpActualCustomerUseCase} from "@app/core/user/application/sign-up-actual-customer.use-case";
import {SignUpNewCustomerUseCase} from "@app/core/user/application/sign-up-new-customer.use-case";
import {NewCostumerSignUpData} from "@app/core/user/domain/dtos/new-costumer-sign-up-data";
import {ActualCostumerSignUpData} from "@app/core/user/domain/dtos/actual-costumer-sign-up-data";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {firstValueFrom, Observable, Subject} from "rxjs";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";
import {map, take} from "rxjs/operators";
import {onError} from "@app/presentation/rxjs-utils/operators/on-error";
import {DeliveryPointSelector} from "@app/core/delivery-point/application/select-delivery-point.use-case";
import {NoDeliveryPostalCodeError} from "@app/core/user/domain/error/no-delivery-postal-code.error";

@Injectable({
    providedIn: 'root',
})
export class SignUpViewModel {

    constructor(
        private signUpNewCustomerUseCase:SignUpNewCustomerUseCase,
        private signUpActualCustomerUseCase:SignUpActualCustomerUseCase
    ) { }

    public notifier = new PopupNotifier();

    private quantityOfDeliveryPointsSubject = new Subject<number>();
    private quantityOfDeliveryPoints$: Observable<number> = this.quantityOfDeliveryPointsSubject.asObservable();

    readonly canSelectDeliveryPoint$ = this.quantityOfDeliveryPoints$.pipe(map(quantity => quantity > 1));

    private signUpStatus = createStatusStore();
    readonly isSignUpLoading$ = this.signUpStatus.isLoading$;

    private askForNoDeliveryPostalCodeConfirmationSubject = new Subject<string>();
    //Ask for confirmation when user send a postal code that has no delivery.
    readonly askForNoDeliveryPostalCodeConfirmation$ = this.askForNoDeliveryPostalCodeConfirmationSubject.asObservable();

    private isSignedUpSubject = new Subject<boolean>();
    readonly isSignedUp$ = this.isSignedUpSubject.asObservable();


    signUpNewCostumer(newCostumerSignUpData:NewCostumerSignUpData, deliveryPointSelector: DeliveryPointSelector): Promise<void> {
        return firstValueFrom(this.signUpNewCustomerUseCase.execute({newCostumerSignUpData, deliveryPointSelector}).pipe(
                take(1),
                onIsLoadingChanges(this.signUpStatus.setIsLoading),
                onError(error => this.handleSignUpError(error))
        ));
    }

    signUpActualCostumer(actualCostumerSignUpData:ActualCostumerSignUpData, deliveryPointSelector: DeliveryPointSelector): Promise<void> {
        return firstValueFrom(this.signUpActualCustomerUseCase.execute({actualCostumerSignUpData, deliveryPointSelector}).pipe(
            take(1),
            onIsLoadingChanges(this.signUpStatus.setIsLoading),
            onError(error => this.handleSignUpError(error)),
        ))
    }

    private handleSignUpError(error: any) {
        if (error instanceof NoDeliveryPostalCodeError) {
            this.askForNoDeliveryPostalCodeConfirmationSubject.next(error.message);
            return;
        }
        this.notifier.notifyError(error);
    }
}
